var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28.0000735px",
    height: "28.0000735px",
    viewBox: "0 0 28.0000735 28.0000735",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-General-On-First-setup-Default",
    transform: "translate(-313, -106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:link",
    transform: "translate(311, 104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6842461,11.1531437 C16.9222014,10.6547506 17.5191298,10.4436241 18.0175229,10.6815794 C20.0687514,11.6609284 21.5167465,13.5752785 21.9008577,15.8156181 C22.2849689,18.0559576 21.5573667,20.3433188 19.9497734,21.9497734 L13.9497734,27.9497734 C11.2160891,30.6834578 6.78391094,30.6834578 4.05022655,27.9497734 C1.31654216,25.2160891 1.31654216,20.7839109 4.05022655,18.0502266 L6.39289322,15.7075599 C6.78341751,15.3170356 7.41658249,15.3170356 7.80710678,15.7075599 C8.19763107,16.0980842 8.19763107,16.7312492 7.80710678,17.1217734 L5.46444011,19.4644401 C3.51180431,21.4170759 3.51180431,24.5829241 5.46444011,26.5355599 C7.41707592,28.4881957 10.5829241,28.4881957 12.5355599,26.5355599 L18.5358104,20.5353095 C19.6842702,19.387663 20.2039861,17.7538336 19.9296209,16.153591 C19.6552558,14.5533485 18.6209736,13.1859555 17.1558104,12.4864206 C16.6574173,12.2484652 16.4462908,11.6515369 16.6842461,11.1531437 Z M18.0502266,4.05022655 C20.7839109,1.31654216 25.2160891,1.31654216 27.9497734,4.05022655 C30.6834578,6.78391094 30.6834578,11.2160891 27.9497734,13.9497734 L25.6071068,16.2924401 C25.2165825,16.6829644 24.5834175,16.6829644 24.1928932,16.2924401 C23.8023689,15.9019158 23.8023689,15.2687508 24.1928932,14.8782266 L26.5355599,12.5355599 C28.4881957,10.5829241 28.4881957,7.41707592 26.5355599,5.46444011 C24.5829241,3.51180431 21.4170759,3.51180431 19.4644401,5.46444011 L13.4641896,11.4646905 C12.3157298,12.612337 11.7960139,14.2461664 12.0703791,15.846409 C12.3447442,17.4466515 13.3790264,18.8140445 14.8441896,19.5135794 C15.3425827,19.7515348 15.5537092,20.3484631 15.3157539,20.8468563 C15.0777986,21.3452494 14.4808702,21.5563759 13.9824771,21.3184206 C11.9312486,20.3390716 10.4832535,18.4247215 10.0991423,16.1843819 C9.7150311,13.9440424 10.4426333,11.6566812 12.0502266,10.0502266 L18.0502266,4.05022655 Z",
    id: "Shape",
    fill: "#192340",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettings);
export default __webpack_public_path__ + "static/media/general-settings.0ee1cd5e218b44e15443fc511c88e245.svg";
export { ForwardRef as ReactComponent };